import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=690e0638&scoped=true"
import script from "./addTemplate.vue?vue&type=script&lang=js"
export * from "./addTemplate.vue?vue&type=script&lang=js"
import style0 from "./addTemplate.vue?vue&type=style&index=0&id=690e0638&scoped=true&lang=scss"
import style1 from "./addTemplate.vue?vue&type=style&index=1&id=690e0638&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e0638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690e0638')) {
      api.createRecord('690e0638', component.options)
    } else {
      api.reload('690e0638', component.options)
    }
    module.hot.accept("./addTemplate.vue?vue&type=template&id=690e0638&scoped=true", function () {
      api.rerender('690e0638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-template/addTemplate.vue"
export default component.exports